import z from 'zod';
import {
  billAmountsValidator,
  emailValidator,
  fullNameValidator,
  honeypotAddressFieldValidator,
  ownHomeValidator,
  phoneValidator,
  zipCodeValidator,
} from '@/utils/validation/inputs';

export enum QualifyStepSchemaMode {
  ZIP_ONLY = 'zipOnly',
  ZIP_AND_BILL = 'zipAndBill',
  ZIP_AND_OWNHOME = 'zipAndOwnHome',
  ALL_FIELDS = 'allFields',
}
export const qualifyStepSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal(QualifyStepSchemaMode.ZIP_ONLY),
    ...zipCodeValidator,
  }),
  z.object({
    mode: z.literal(QualifyStepSchemaMode.ZIP_AND_BILL),
    ...zipCodeValidator,
    ...billAmountsValidator,
  }),
  z.object({
    mode: z.literal(QualifyStepSchemaMode.ZIP_AND_OWNHOME),
    ...zipCodeValidator,
    ...ownHomeValidator,
  }),
  z.object({
    mode: z.literal(QualifyStepSchemaMode.ALL_FIELDS),
    ...zipCodeValidator,
    ...ownHomeValidator,
    ...billAmountsValidator,
  }),
]);
export type QualifyStepSchemaType = z.infer<typeof qualifyStepSchema>;

export enum SubmitStepSchemaMode {
  WITH_EMAIL = 'withEmail',
  WITHOUT_EMAIL = 'withoutEmail',
}
export const submitStepSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal(SubmitStepSchemaMode.WITH_EMAIL),
    ...fullNameValidator,
    ...emailValidator,
    ...phoneValidator,
    ...honeypotAddressFieldValidator,
  }),
  z.object({
    mode: z.literal(SubmitStepSchemaMode.WITHOUT_EMAIL),
    ...fullNameValidator,
    ...phoneValidator,
    ...honeypotAddressFieldValidator,
  }),
]);
export type SubmitStepSchemaType = z.infer<typeof submitStepSchema>;
